export default {
  path: '/certificados-de-temperatura/:id',
  component: () => import('@/components/pages/TemperatureCertificates/TemperatureCertificate.vue')
}
